import { Heading } from '@chakra-ui/react';
import { IContactRespSchema } from '@monetize/types/app';
import { MBox, MText, MVStack } from '../../../components/Monetize';

interface QuoteShareEsignContactProps {
  contact: IContactRespSchema;
}

/**
 * The eSign signer is set on the quote and cannot be changed from the share
 * page, so it renders read-only alongside the billing/shipping contacts.
 */
export const QuoteShareEsignContact = ({
  contact,
}: QuoteShareEsignContactProps) => {
  return (
    <MBox>
      <Heading as="h3" fontSize="sm" fontWeight="500">
        eSign Contact
      </Heading>
      <MVStack alignItems="flex-start" gap="0.2rem" mb="0.8rem">
        <MText lineClamp={1}>{contact.fullName}</MText>
        <MText lineClamp={1}>{contact.email}</MText>
      </MVStack>
    </MBox>
  );
};
